import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/app/[locale]/(public)/not-found.tsx");
